import { render, staticRenderFns } from "./AuthenticatedNav.vue?vue&type=template&id=2705ecd7&scoped=true"
import script from "./AuthenticatedNav.vue?vue&type=script&lang=js"
export * from "./AuthenticatedNav.vue?vue&type=script&lang=js"
import style0 from "./AuthenticatedNav.vue?vue&type=style&index=0&id=2705ecd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2705ecd7",
  null
  
)

export default component.exports